const firebaseConfig = {
    apiKey: "AIzaSyApYZbnoMki2XQdLOMoyP8NECltwL6CiRE",
    authDomain: "insightplus-mpm.firebaseapp.com",
    databaseURL: "https://insightplus-mpm.firebaseio.com",
    projectId: "insightplus-mpm",
    storageBucket: "insightplus-mpm.appspot.com",
    messagingSenderId: "654809405903",
    appId: "1:654809405903:web:c10a52a69c9dfa7c479aba",
    measurementId: "G-EV1J30T00M"
};

export default firebaseConfig;